import React, { useEffect, useState } from 'react'
import Logo from '../Images/kuza-white.svg'
import { NavLink } from "react-router-dom";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faAdd } from '@fortawesome/free-solid-svg-icons';
import { Link } from 'react-router-dom';

const codeBlock = (lang, code) => (
    <div className="mb-4">
        <p className="fw-bold mb-1">{lang}</p>
        <pre className="bg-light p-3 border rounded small">
            <code>{code}</code>
        </pre>
    </div>
)

function APIDocs() {

   const sections = [
  { id: "issue-points", label: "Issue Points" },
  { id: "redeem-points", label: "Send OTP (Redeem)" },
  { id: "verify-otp", label: "Verify OTP" },
  { id: "view-clients", label: "View Clients" },
  { id: "redeemed-points", label: "Redeemed Points" }
];

    const [activeSection, setActiveSection] = useState("issue-points");

    useEffect(() => {
        const handleScroll = () => {
            let current = "issue-points";
            sections.forEach(sec => {
                const el = document.getElementById(sec.id);
                if (el && window.scrollY >= el.offsetTop - 120) {
                    current = sec.id;
                }
            });
            setActiveSection(current);
        };

        window.addEventListener("scroll", handleScroll);
        return () => window.removeEventListener("scroll", handleScroll);
    }, []);

    return (
        <div className="container-fluid">
            <div className="row">

                {/* Left Sidebar */}
                <div className="col-md-3 d-none d-md-block myPrimaryBg vh-100 position-fixed">
                    <div className="py-4 ps-3">
                        <Link to="/">
                            <div className='logocontainer'>
                                <img src={Logo} alt="" className='logo' />
                            </div>
                        </Link>

                        <ul className="nav flex-column">
                            {sections.map(({ id, label }) => (
                                <div className='leftLinkCont d-flex align-items-center' key={id}>
                                    <a
                                        href={`#${id}`}
                                        className={`leftNavLinks ${activeSection === id ? 'active' : ''}`}
                                    >
                                        {label}
                                    </a>
                                </div>
                            ))}
                        </ul>

                    </div>
                </div>

                {/* Main Content */}
                <div className="col-md-9 offset-md-3 px-4 py-5">
                    <h1 className="mb-3 myPrimaryColor">Kuza Points API Documentation</h1>
                    <p className="text-muted mb-5">Simple REST API for issuing, viewing and redeeming loyalty points.</p>

                    {/* Authentication */}
                    <section className="mb-5">


                        <h2 className="h5">Authentication</h2>
<p>
  All requests to the Kuza Points API must be authenticated using an API key. 
  Your API key acts as your unique identifier and allows you to securely interact with the API.
</p>

<p className="mt-3">
  <strong>Where to get your API Key:</strong><br />
  After registering your business on Kuza Points, visit your dashboard under the <strong>Settings</strong> section to generate or copy your API key.
</p>

<p className="mt-3">
 <strong>Include the key in your headers like this:</strong>
</p>
<pre className="bg-light p-3 border rounded small">
  x-api-key: YOUR_API_KEY
</pre>

                    </section>

                    {/* Issue Points */}
                    <section id="issue-points" className="mb-5">
                        <h2 className="h5">Issue Points</h2>
                        <p><strong>POST</strong> <code>https://api.kuzapoints.com/issue-points</code></p>
                        <p>Issue 1 point to a customer.</p>
                        <pre className="bg-light p-3 border rounded small">
                            {`{
  "name": "Reinhard",
  "phone": "0712345678"
}`}
                        </pre>
                        <h6 className="mt-4 text-muted">Sample Code</h6>
                        {codeBlock("Node.js (Axios)", `const axios = require('axios');

axios.post('https://api.kuzapoints.com/issue-points', {
  name: "Reinhard",
  phone: "0712345678"
}, {
  headers: {
    "Content-Type": "application/json",
    "x-api-key": "YOUR_API_KEY"
  }
}).then(res => console.log(res.data)).catch(err => console.error(err.response?.data || err.message));`)}

                        {codeBlock("Python", `import requests

headers = {
    "x-api-key": "YOUR_API_KEY",
    "Content-Type": "application/json"
}
data = {
    "name": "Reinhard",
    "phone": "0712345678"
}

res = requests.post("https://api.kuzapoints.com/issue-points", json=data, headers=headers)
print(res.json())
`)}

                        {codeBlock("Java (Android)", `
OkHttpClient client = new OkHttpClient();

MediaType JSON = MediaType.get("application/json; charset=utf-8");
String json = "{"
    + "\"name\":\"Reinhard\","
    + "\"phone\":\"0712345678\""
    + "}";

RequestBody body = RequestBody.create(json, JSON);
Request request = new Request.Builder()
    .url("https://api.kuzapoints.com/issue-points")
    .post(body)
    .addHeader("x-api-key", "YOUR_API_KEY")
    .addHeader("Content-Type", "application/json")
    .build();

client.newCall(request).enqueue(new Callback() {
    @Override
    public void onFailure(Call call, IOException e) {
        e.printStackTrace();
    }

    @Override
    public void onResponse(Call call, Response response) throws IOException {
        String responseBody = response.body().string();
        Log.d("API_RESPONSE", responseBody);
    }
});

`)}

                        {codeBlock("PHP", `<?php
$url = "https://api.kuzapoints.com/issue-points";

$data = [
    "name" => "Reinhard",
    "phone" => "0712345678"
];

$headers = [
    "Content-Type: application/json",
    "x-api-key: YOUR_API_KEY"
];

$ch = curl_init($url);
curl_setopt($ch, CURLOPT_POST, true);
curl_setopt($ch, CURLOPT_POSTFIELDS, json_encode($data));
curl_setopt($ch, CURLOPT_RETURNTRANSFER, true);
curl_setopt($ch, CURLOPT_HTTPHEADER, $headers);

$response = curl_exec($ch);
curl_close($ch);

echo $response;

`)}

                    </section>

                    {/*  Redeem Points */}
                    <section id="redeem-points" className="mb-5">
                        <h2 className="h5">Redeem Points (Send OTP)</h2>
                        <p><strong>POST</strong> <code>https://api.kuzapoints.com/redeem-points</code></p>
                        <p>Send OTP to customer to initiate point redemption.</p>
                        <pre className="bg-light p-3 border rounded small">
                            {`{
  "phoneNumber": "0712345678",
  "amount": 50
}`}
                        </pre>
                        {codeBlock("Node.js (Axios)", `const axios = require('axios');

axios.post('https://api.kuzapoints.com/redeem-points', {
  phoneNumber: "0712345678",
  amount: 50
}, {
  headers: {
    "Content-Type": "application/json",
    "x-api-key": "YOUR_API_KEY"
  }
}).then(res => console.log(res.data)).catch(err => console.error(err.response?.data || err.message));`)}

                        {codeBlock("Python", `import requests

headers = {
    "x-api-key": "YOUR_API_KEY",
    "Content-Type": "application/json"
}
data = {
    "phoneNumber": "0712345678",
    "amount": 50
}

res = requests.post("https://api.kuzapoints.com/redeem-points", json=data, headers=headers)
print(res.json())
` )}

                        {codeBlock("Java (Android)", `
OkHttpClient client = new OkHttpClient();

MediaType JSON = MediaType.get("application/json; charset=utf-8");
String json = "{"
    + "\"phoneNumber\":\"0712345678\","
    + "\"amount\":50"
    + "}";

RequestBody body = RequestBody.create(json, JSON);
Request request = new Request.Builder()
    .url("https://api.kuzapoints.com/redeem-points")
    .post(body)
    .addHeader("x-api-key", "YOUR_API_KEY")
    .addHeader("Content-Type", "application/json")
    .build();

client.newCall(request).enqueue(new Callback() {
    @Override
    public void onFailure(Call call, IOException e) {
        e.printStackTrace();
    }

    @Override
    public void onResponse(Call call, Response response) throws IOException {
        String responseBody = response.body().string();
        Log.d("API_RESPONSE", responseBody);
    }
});

` )}

                        {codeBlock("PHP", `<?php
$url = "https://api.kuzapoints.com/redeem-points";

$data = [
    "phoneNumber" => "0712345678",
    "amount" => 50
];

$headers = [
    "Content-Type: application/json",
    "x-api-key: YOUR_API_KEY"
];

$ch = curl_init($url);
curl_setopt($ch, CURLOPT_POST, true);
curl_setopt($ch, CURLOPT_POSTFIELDS, json_encode($data));
curl_setopt($ch, CURLOPT_RETURNTRANSFER, true);
curl_setopt($ch, CURLOPT_HTTPHEADER, $headers);

$response = curl_exec($ch);
curl_close($ch);

echo $response;
`)}
                    </section>

                    {/* Verify OTP */}
                    <section id="verify-otp" className="mb-5">
                        <h2 className="h5">Verify OTP and Redeem</h2>
                        <p><strong>POST</strong> <code>https://api.kuzapoints.com/verify-otp</code></p>
                        <p>Verify OTP and redeem customer points.</p>
                        <pre className="bg-light p-3 border rounded small">
                            {`{
  "phoneNumber": "0712345678",
  "otp": "123456"
}`}
                        </pre>
                        {codeBlock("Node.js (Axios)", `const axios = require('axios');

axios.post('https://api.kuzapoints.com/verify-otp', {
  phoneNumber: "0712345678",
  otp: "123456"
}, {
  headers: {
    "Content-Type": "application/json",
    "x-api-key": "YOUR_API_KEY"
  }
}).then(res => console.log(res.data)).catch(err => console.error(err.response?.data || err.message));`)}

                        {codeBlock("Python", `import requests

headers = {
    "x-api-key": "YOUR_API_KEY",
    "Content-Type": "application/json"
}
data = {
    "phoneNumber": "0712345678",
    "otp": "123456"  # Replace with real OTP sent to phone
}

res = requests.post("https://api.kuzapoints.com/verify-otp", json=data, headers=headers)
print(res.json())
`)}


                        {codeBlock("Java (Android)", `OkHttpClient client = new OkHttpClient();

MediaType JSON = MediaType.get("application/json; charset=utf-8");
String json = "{"
    + "\"phoneNumber\":\"0712345678\","
    + "\"otp\":\"123456\""
    + "}";

RequestBody body = RequestBody.create(json, JSON);
Request request = new Request.Builder()
    .url("https://api.kuzapoints.com/verify-otp")
    .post(body)
    .addHeader("x-api-key", "YOUR_API_KEY")
    .addHeader("Content-Type", "application/json")
    .build();

client.newCall(request).enqueue(new Callback() {
    @Override
    public void onFailure(Call call, IOException e) {
        e.printStackTrace();
    }

    @Override
    public void onResponse(Call call, Response response) throws IOException {
        String responseBody = response.body().string();
        Log.d("API_RESPONSE", responseBody);
    }
});

`)}

                        {codeBlock("PHP", `<?php
$url = "https://api.kuzapoints.com/verify-otp";

$data = [
    "phoneNumber" => "0712345678",
    "otp" => "123456"
];

$headers = [
    "Content-Type: application/json",
    "x-api-key: YOUR_API_KEY"
];

$ch = curl_init($url);
curl_setopt($ch, CURLOPT_POST, true);
curl_setopt($ch, CURLOPT_POSTFIELDS, json_encode($data));
curl_setopt($ch, CURLOPT_RETURNTRANSFER, true);
curl_setopt($ch, CURLOPT_HTTPHEADER, $headers);

$response = curl_exec($ch);
curl_close($ch);

echo $response;
`)}
                    </section>

                    {/* View Clients */}
                    <section id="view-clients" className="mb-5">
                        <h2 className="h5">View Clients</h2>
                        <p><strong>GET</strong> <code>https://api.kuzapoints.com/rewards</code></p>
                        <p>Returns all customers you've issued points to.</p>
                        {codeBlock("Node.js (Axios)", `const axios = require('axios');

axios.get('https://api.kuzapoints.com/rewards', {
  headers: {
    "x-api-key": "YOUR_API_KEY"
  }
}).then(res => console.log(res.data)).catch(err => console.error(err.response?.data || err.message));`)}

                        {codeBlock("Python", `import requests

headers = {
    "x-api-key": "YOUR_API_KEY"
}

res = requests.get("https://api.kuzapoints.com/redeemed-points", headers=headers)
print(res.json())
`)}

                        {codeBlock("Java (Android)", `OkHttpClient client = new OkHttpClient();

Request request = new Request.Builder()
    .url("https://api.kuzapoints.com/redeemed-points")
    .get()
    .addHeader("x-api-key", "YOUR_API_KEY")
    .build();

client.newCall(request).enqueue(new Callback() {
    @Override
    public void onFailure(Call call, IOException e) {
        e.printStackTrace();
    }

    @Override
    public void onResponse(Call call, Response response) throws IOException {
        String responseBody = response.body().string();
        Log.d("API_RESPONSE", responseBody);
    }
});

`)}

                        {codeBlock("PHP", `<?php
$url = "https://api.kuzapoints.com/redeemed-points";

$headers = [
    "x-api-key: YOUR_API_KEY"
];

$ch = curl_init($url);
curl_setopt($ch, CURLOPT_RETURNTRANSFER, true);
curl_setopt($ch, CURLOPT_HTTPHEADER, $headers);

$response = curl_exec($ch);
curl_close($ch);

echo $response;
`)}
                    </section>

                    {/*View Redeemed Points */}
                    <section id="redeemed-points" className="mb-5">
                        <h2 className="h5">View Redeemed Points</h2>
                        <p><strong>GET</strong> <code>https://api.kuzapoints.com/redeemed-points</code></p>
                        <p>Returns all point redemptions by customers.</p>
                        {codeBlock("Node.js (Axios)", `const axios = require('axios');

axios.get('https://api.kuzapoints.com/redeemed-points', {
  headers: {
    "x-api-key": "YOUR_API_KEY"
  }
}).then(res => console.log(res.data)).catch(err => console.error(err.response?.data || err.message));`)}

                        {codeBlock("Python", ` import requests

headers = {
    "x-api-key": "YOUR_API_KEY"
}

res = requests.get("https://api.kuzapoints.com/redeemed-points", headers=headers)
print(res.json())
`)}

                        {codeBlock("Java (Android)", ` OkHttpClient client = new OkHttpClient();

Request request = new Request.Builder()
    .url("https://api.kuzapoints.com/redeemed-points")
    .get()
    .addHeader("x-api-key", "YOUR_API_KEY")
    .build();

client.newCall(request).enqueue(new Callback() {
    @Override
    public void onFailure(Call call, IOException e) {
        e.printStackTrace();
    }

    @Override
    public void onResponse(Call call, Response response) throws IOException {
        String responseBody = response.body().string();
        Log.d("API_RESPONSE", responseBody);
    }
});

`)}

                        {codeBlock("PHP", `<?php
$url = "https://api.kuzapoints.com/redeemed-points";

$headers = [
    "x-api-key: YOUR_API_KEY"
];

$ch = curl_init($url);
curl_setopt($ch, CURLOPT_RETURNTRANSFER, true);
curl_setopt($ch, CURLOPT_HTTPHEADER, $headers);

$response = curl_exec($ch);
curl_close($ch);

echo $response;
`)}
                    </section>

                    <footer className="text-muted small text-center mt-5">
                        &copy; {new Date().getFullYear()} Kuza Points. Built for developers
                    </footer>
                </div>
            </div>
        </div>
    )
}

export default APIDocs;
